import { useEffect, useId, useMemo, useState } from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';

const FLASHCARD_OPTIONS = [
	{ value: 'all', label: 'Todas' },
    { value: 'new', label: 'Nuevas' },
	{ value: 'due', label: 'Tarjetas pendientes' },
	{ value: 'incorrect', label: 'Tarjetas con errores previos' },
];

export default function RadioGroupFlashcards({
	title = 'Tipo de tarjetas',
	value,
	onChange,
	accentColor = '#6366f1',
}) {
	const id = useId();
	const availableValues = useMemo(() => FLASHCARD_OPTIONS.map((option) => option.value), []);
	const fallbackValue = availableValues[0];
	const [selectedValue, setSelectedValue] = useState(value || fallbackValue);

	useEffect(() => {
		setSelectedValue(value || fallbackValue);
	}, [value, fallbackValue]);

	useEffect(() => {
		if (!availableValues.includes(selectedValue)) {
			setSelectedValue(fallbackValue);
			onChange?.(fallbackValue);
		}
	}, [availableValues, fallbackValue, onChange, selectedValue]);

	const handleChange = (event, newValue) => {
		setSelectedValue(newValue);
		onChange?.(newValue);
	};

	const labelSx = {
		'& .MuiFormControlLabel-label': {
			fontWeight: 400,
			color: '#4b5563',
			fontSize: '0.875rem',
		},
	};

	const radioSx = {
		color: accentColor,
		'&.Mui-checked': {
			color: accentColor,
		},
	};

	return (
		<>
			<h3 className="text-sm font-semibold mb-2">{title}</h3>
			<FormControl sx={{ width: '100%' }}>
				<RadioGroup
					row
					aria-labelledby={`${id}-label`}
					name="flashcards-radio-group"
					sx={{
						width: '100%',
						justifyContent: 'center',
						alignItems: 'center',
						flexWrap: 'wrap',
						columnGap: 1,
					}}
					value={selectedValue}
					onChange={handleChange}
				>
					{FLASHCARD_OPTIONS.map((option) => (
						<FormControlLabel
							key={option.value}
							value={option.value}
							control={<Radio sx={radioSx} />}
							label={option.label}
							sx={labelSx}
						/>
					))}
				</RadioGroup>
			</FormControl>
		</>
	);
}
